import moment from 'moment-timezone';

export const DEFAULT_DATE_LANGUAGE = 'en-GB';

export interface FormatDateOptions {
  language?: string;
  timeZone?: string;
}

/**
 * Pure date-text formatter: "MMMM Do yyyy" (e.g. "June 17th 2026").
 * No time-of-day logic lives here on purpose - this function cannot
 * affect how any time is computed or displayed.
 *
 * End goal is to use this formatter for every date displayed across the app,
 * but MIW-139 only changes the 3 fields named in its AC, to keep scope small.
 */
export function formatDate(
  date: Date,
  {
    language = DEFAULT_DATE_LANGUAGE,
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
  }: FormatDateOptions = {}
): string {
  return moment(date).tz(timeZone).locale(language).format('MMMM Do yyyy');
}
